import axios from 'axios'
import swal from 'sweetalert2'
import store from '@/lib/store'
import router from '@/plugins/router'
import { jiminnyHost } from '@/helpers/region'

export default {
  async fetchActivity ({state, dispatch}) {
    try {
      const response = await axios.get(`${jiminnyHost()}/api/v1/activity/softphone/${state.activity.id}`)
      dispatch('setActivity', response.data)
    } catch (error) {
      console.error(error)
    }
  },
  setActivity ({ commit }, activity) {
    if (!activity.privateMessages) {
      activity.privateMessages = []
    }
    commit('SET_ACTIVITY', activity)
  },
  unsetActivity ({ commit }) {
    commit('UNSET_ACTIVITY', null)
  },
  resetState ({ dispatch }) {
    dispatch('unsetActivity')
    dispatch('hideDialpad')
    dispatch('hideNotepad')
    dispatch('hideLiveCoachChat')
    dispatch('setIsMuted', { isMuted: false, isGhost: false })
    dispatch('setIsMuted', { isMuted: true, isGhost: true })
    dispatch('markRecordingButtonDisabled', false)
  },
  showDialpad ({ commit }) {
    commit('SHOW_DIALPAD')
  },
  hideDialpad ({ commit }) {
    commit('HIDE_DIALPAD')
  },
  showNotepad ({ commit }) {
    commit('SHOW_NOTEPAD')
  },
  hideNotepad ({ commit }) {
    commit('HIDE_NOTEPAD')
  },
  showLiveCoachChat ({ state, commit, dispatch }) {
    commit('SHOW_LIVE_COACH_CHAT')

    if (state.dialpadVisible) {
      dispatch('hideDialpad')
    }

    if (state.notepadVisible) {
      dispatch('hideNotepad')
    }
  },
  hideLiveCoachChat ({ commit }) {
    commit('HIDE_LIVE_COACH_CHAT')
  },
  startRecording ({ state, dispatch }, swalErrorData) {
    axios
    .post(`${jiminnyHost()}/api/v1/activity/${state.activity.id}/recording`)
    .catch(error => {
      console.log(error)
      swal(swalErrorData)
      dispatch('markRecordingButtonDisabled', false)
    })
  },
  pauseRecording ({ state, dispatch }, swalErrorData) {
    axios
    .put(`${jiminnyHost()}/api/v1/activity/${state.activity.id}/recording`, {
      state: 'paused'
    })
    .catch(error => {
      console.log(error)
      swal(swalErrorData)
      dispatch('markRecordingButtonDisabled', false)
    })
  },
  resumeRecording ({ state, dispatch }, swalErrorData) {
    axios
    .put(`${jiminnyHost()}/api/v1/activity/${state.activity.id}/recording`, {
      state: 'in-progress'
    })
    .catch(error => {
      console.log(error)
      swal(swalErrorData)
      dispatch('markRecordingButtonDisabled', false)
    })
  },
  stopRecording ({ state, dispatch }, swalErrorData) {
    axios
    .delete(`${jiminnyHost()}/api/v1/activity/${state.activity.id}/recording`)
    .catch(error => {
      console.log(error)
      swal(swalErrorData)
      dispatch('markRecordingButtonDisabled', false)
    })
  },
  markRecordingState ({ commit }, recordingState) {
    commit('MARK_RECORDING_STATE', recordingState)
  },
  markRecordingButtonDisabled ({ commit }, recordingButtonDisabled) {
    commit('MARK_RECORDING_BUTTON_DISABLED', recordingButtonDisabled)
  },
  setIsMuted ({ commit }, { isMuted, isGhost }) {
    isGhost
      ? commit('SET_IS_COACH_MUTED', isMuted)
      : commit('SET_IS_REP_MUTED', isMuted)
  },
  addPrivateMessage ({ commit }, message) {
    commit('ADD_PRIVATE_MESSAGE', message)
  },
  exitCallScreen ({state}) {
    const team = store.get('team')
    const { autoSyncActivity } = team.crm
    const isProspectPresent = !!state.activity.prospect

    if (autoSyncActivity && isProspectPresent) {
      router.push({
        path: '/contacts'
      })
    } else {
      router.push({
        path: '/activity-summary',
        query: {
          id: state.activity.id
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/conference/actions.js